import { render, staticRenderFns } from "./NoPage.vue?vue&type=template&id=5ff1b28d&scoped=true&"
import script from "./NoPage.ts?vue&type=script&lang=ts&"
export * from "./NoPage.ts?vue&type=script&lang=ts&"
import style0 from "./NoPage.vue?vue&type=style&index=0&id=5ff1b28d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1b28d",
  null
  
)

export default component.exports